import { onReady } from '../lib/on-ready.js';

function initFlipCards() {
    document.querySelectorAll('.flip-card').forEach((card) => {
        card.addEventListener('click', () => {
            card.classList.toggle('flip');
        });

        const cardBody = card.querySelector('.flip-card-body');
        const links = cardBody ? Array.from(cardBody.querySelectorAll('a')) : [];
        if (!links.length) {
            return;
        }

        const addFlip = () => card.classList.add('flip');
        let flipTimeout;
        const removeFlip = () => {
            clearTimeout(flipTimeout);
            flipTimeout = setTimeout(() => {
                const activeElement = document.activeElement;
                const isFocused = card.contains(activeElement) &&
                    (activeElement === card || links.includes(activeElement));
                if (!isFocused) {
                    card.classList.remove('flip');
                }
            }, 100);
        };

        card.addEventListener('focus', addFlip);
        card.addEventListener('blur', removeFlip);
        links.forEach((link) => {
            link.addEventListener('focus', addFlip);
            link.addEventListener('blur', removeFlip);
        });
    });
}

onReady(initFlipCards);
